<template>
    <vs-button class="mg-btn-gold" color="primary" text-color="whiteprimary"  v-on:click="modalOpen">Add Ticket</vs-button>    
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#TicketModals" id="addTicketBtn"> </button>             
    <div class="modal fade right" id="TicketModals" tabindex="-1" style="display: none;" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">            
            <div class="modal-content">
                <div class="modal-header">
                    <input type="hidden" name="ticketValId" id="ticketValId">
                    <h5 class="modal-title">{{ modalType }} Ticket</h5> 
                    <button type="button" class="btn-close" id="closePop" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <form @submit.prevent="onSubmit" class="ticketFrm" id="ticketFrm"  enctype="multipart/form-data" >
                    <div class="modal-body setformbackform">
                        <div class="row">
                            <div class="col-sm-12">
                                <span v-if="errorMessage != ''">
                                    <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                                </span>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="user_id" class="form-label">UserID<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="user_id" id="user_id" placeholder="Enter name"  v-model="v$.form.user_id.$model"> 
                                    <div class="input-errors" v-for="(error, index) of v$.form.user_id.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="title" class="form-label">Title<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="title" id="title" placeholder="Enter title"  v-model="v$.form.title.$model"> 
                                    <div class="input-errors" v-for="(error, index) of v$.form.title.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div> 
                            </div>
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="title" class="form-label">Issue (enter your query)</label> 
                                    <!-- <input type="text" class="form-control" name="title" id="title" placeholder="Enter issue"  v-model="v$.form.title.$model">  -->
                                    <textarea name="issue" v-model="v$.form.issue.$model" class="form-control" placeholder="Enter issue" v-on:keyup="textareaFun" id="textarea"/>
                                    <div class="input-errors" v-for="(error, index) of v$.form.title.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div> 
                            </div>
                            <div class="col-sm-12">
                                <file-pond
                                    name="file"
                                    v-model="file"
                                    ref="pond"
                                    label-idle="Drop files here..."
                                    v-bind:allow-multiple="true"
                                    accepted-file-types="image/jpeg, image/png, application/pdf, application/zip"
                                    instantUpload=false
                                    max-files="5"
                                    v-bind:files="myFiles"
                                    @updatefiles="updateFiles"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">                           
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-on:click="addTicket" v-if="formLoader === 1">{{ buttonName }}</button>
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import useVuelidate from '@vuelidate/core'
import $ from "jquery";
import {
    required,
    helpers,
    minLength
} from '@vuelidate/validators'
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);
export default {
    name: 'AddTicketPage',
    emits: ['reloadTableData'], 
    components: {
        // Select2,
        FilePond
    },
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            modalType: 'Add',
            buttonName: 'Save',
            errorMessage: '',
            formLoader: 1,
            logoFile: null,
            file: [], // Holds uploaded files
                files: [],
                myFiles: [],
            form: {
                user_id: '',
                title: '',
                issue: '',
                password: '',
                passwordEdit: '',
            },
        }
    },
    methods: {
        startLoader () {
            this.$Progress.start()
        },
        finishLoader () {
            this.$Progress.finish()
        },
        textareaFun() {
            var textarea = document.getElementById("textarea");
            textarea.style.height = "";
            textarea.style.height = Math.min(textarea.scrollHeight, 200) + "px";
        },
        updateFiles(newFiles) {            
            this.files = newFiles.map((file) => file.file);
        },
        async modalOpen() {
            this.errorMessage = ''
            this.form.user_id = '';
            this.form.title = '';
            this.form.issue = '';
            this.isNewImg = 0;
            this.modalType = 'Add';
            this.buttonName = 'Save',
            this.logoFile = null,
            this.files = []
            this.$nextTick(() => {
            if (this.$refs.pond) {
                this.$refs.pond.removeFiles();
                }
            });
            this.v$.$reset()
            document.getElementById('ticketValId').value = '';
            document.getElementById('addTicketBtn').click();
            setTimeout(async () =>
                $("#user_id").focus(),
            500);
        },
        async addTicket() {
            this.formLoader = 2
            let _URL = ''
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;

            _URL = process.env.VUE_APP_API_URL + 'ticket/create'
            const fd = new FormData;
            fd.append('user_id', this.form.user_id)
            fd.append('title', this.form.title)
            fd.append('issue', this.form.issue)
            this.files.forEach((file) => {
                fd.append("files", file);
            });
            this.startLoader()
            await axios.post(_URL, fd)
            .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closePop').click();
                    this.$toast.success(resp.data.message);
                    this.$emit('reload-table-data');
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                }
                    this.formLoader = 1
                    this.finishLoader()
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.errorRes = error.response.data.message;
                this.formLoader = 1
            })            
        },
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                user_id: {
                    required: helpers.withMessage('Please enter user id', required),
                    min: minLength(2),
                    noSpaces: helpers.withMessage('Spaces are not allowed', (value) => !/\s/.test(value))
                },
                title: {
                    required,
                    min: minLength(2),
                },
                issue: {
                    min: minLength(2),
                }
            },
        }
    },

}
</script>
<style scoped>
.img-thumbnail{
    width: 100px;
    height: 100px;
}
</style>